import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ breakpoints, shape, custom }: Theme) => ({
    root: {
      position: 'absolute',
      zIndex: 3,
      width: '100%',
      fontSize: 14,
      paddingBottom: 2,
    },
    multiItems: {
      justifyContent: 'center',
    },
    menuItem: {
      flexWrap: 'wrap',
      fontFamily: 'inherit',
      '&$selected': {
        backgroundColor: custom.status.warning.main,
        borderRadius: shape.borderRadius,
      },
      '&$selected:hover': {
        color: 'inherit',
        backgroundColor: custom.status.warning.main,
        borderRadius: shape.borderRadius,
      },
      borderRadius: shape.borderRadius,
      height: 'auto',
      padding: '5px 10px',
      fontSize: 14,
      '&:hover': {
        backgroundColor: custom.grey[0],
        borderRadius: shape.borderRadius,
      },
    },
    menuItemTitle: {
      display: 'block',
      width: '100%',
    },
    menuItemSubtitle: {
      display: 'flex',
      width: '80%',
      justifyContent: 'space-between',
      color: custom.grey[2],
      fontSize: 12,
    },
    selected: {},
    [breakpoints.down(426)]: {
      root: {
        left: 0,
        minWidth: 0,
        width: '100%',
        '& > li': {
          whiteSpace: 'normal',
          marginBottom: 15,
        },
      },
    },
    groupHeader: {
      fontSize: 12,
      fontWeight: 'normal',
      color: custom.grey[3],
      opacity: 0.5,
      lineHeight: '20px',
      margin: '0 0 10px 10px',
      '&:not(:first-child)': {
        marginTop: 10,
      },
    },
  })
);
